const ReportTemplateReformatCopyData = (listRawData) => {
  const _list = [];
  for (let rawData of listRawData) {
    const row = {};

    if (rawData.data_trailer) {
      row["nomor"] = rawData.data_trailer.nomor;
      row["tanggal"] = rawData.tanggal;
      row["group"] = rawData.label_grup;
      row["keterangan"] = rawData.keterangan;

      _list.push(row);
    }
  }
  return _list;
};

export default ReportTemplateReformatCopyData;
